let authClient: any = null

export const setAuthClient = (client: any): void => {
  authClient = client
}

export const getAuthClient = (): any => authClient
